(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["off-hours-gate"]) return;
  try {
    
  (() => {
    const gate = document.getElementById('oh-gate');
    if (!gate || gate.dataset.initialized) return;
    gate.dataset.initialized = 'true';
    const key = 'off_hours_gate_v1';
    const preview = new URLSearchParams(location.search).get('oh_gate_preview') === '1';
    let remembered = false;
    try { remembered = sessionStorage.getItem(key) === 'everywhere'; } catch (_) {}
    if (remembered && !preview && !Shopify.designMode) return;
    const previousOverflow = document.body.style.overflow;
    gate.showModal();
    document.body.style.overflow = 'hidden';
    gate.addEventListener('cancel', event => event.preventDefault());
    document.getElementById('oh-no').addEventListener('click', () => {
      document.getElementById('oh-error').hidden = false;
    });
    document.getElementById('oh-yes').addEventListener('click', () => {
      document.getElementById('oh-age-step').hidden = true;
      document.getElementById('oh-location-step').hidden = false;
      gate.setAttribute('aria-labelledby', 'oh-location-heading');
      document.getElementById('oh-location-heading').focus();
    });
    document.getElementById('oh-everywhere').addEventListener('click', event => {
      if (location.hostname !== 'shop.offhoursbrand.com') return;
      event.preventDefault();
      try { sessionStorage.setItem(key, 'everywhere'); } catch (_) {}
      gate.close();
      document.body.style.overflow = previousOverflow;
      const main = document.getElementById('MainContent');
      if (main) main.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
